module.exports = __webpack_public_path__ + "img/casino-dowin.2e96ce93.jpg";